import { useEffect, useState } from 'react';

export function useLiveValue<T>(predicate: () => T, interval = 1000) {
  const [value, setValue] = useState(predicate);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setValue(predicate);
    }, interval);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return value;
}
